import React from 'react';
import styles from './actSlotAdd.module.css';

const AddedSlots = ({ slots = [], onEdit, onRemove }) => {
    if (!slots.length) {
        return null;
    }

    return (
        <>
            {slots.map((slot, index) => (
                <div key={`${slot.startTime}-${slot.endTime}-${index}`} className={styles.newSlotRow}>
                    <div className={styles.newSlotInfo}>
                        <div className={styles.newSlotIcon}>◷</div>

                        <div>
                            <div className={styles.newSlotTime}>
                                {slot.startTime}
                                {' – '}
                                {slot.endTime}
                            </div>

                            <div className={styles.newSlotTotal}>{slot.totalSlots} slots</div>
                        </div>
                    </div>

                    <div className={styles.newSlotActions}>
                        <button
                            type='button'
                            className={styles.editSlotBtn}
                            onClick={() => onEdit?.(index)}
                            title='Edit slot'
                            aria-label='Edit slot'
                        >
                            ✎
                        </button>

                        <button
                            type='button'
                            className={styles.removeSlotBtn}
                            onClick={() => onRemove?.(index)}
                            title='Remove slot'
                            aria-label='Remove slot'
                        >
                            ×
                        </button>
                    </div>
                </div>
            ))}
        </>
    );
};

export default AddedSlots;
